<template lang="pug" src="./services-supplies.pug"></template>

<script>
import Consultation from 'custom/custom-services-consultation/custom-services-consultation'
import Header from 'custom/custom-services-header/custom-services-header'
import Hero from 'components/hero/hero'
import Partnership from 'custom/custom-services-partnership/custom-services-partnership'
import Supplies from 'custom/custom-services-supplies/custom-services-supplies'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages['services-supplies']
    }
  },
  components: {
    Consultation,
    Header,
    Hero,
    Partnership,
    Supplies
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/services-supplies/services-supplies.vue